<template>
  <div :id="componentId" class="spm6-cultivation" :style="{ backgroundColor: bgColor }">
    <div class="spm6-cultivation-list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="spm6-cultivation-card"
      >
        <img
          v-if="item.imageUrl"
          class="spm6-cultivation-image"
          referrerpolicy="no-referrer"
          :src="item.imageUrl"
          @click="goTo(item)"
        />
        <span class="spm6-cultivation-title" @click="goTo(item)">{{ item.title }}</span>
        <div class="spm6-cultivation-items">
          <span
            v-for="(sub, subIndex) in item.itemList"
            :key="subIndex"
            class="spm6-cultivation-sub"
            @click="goTo(sub)"
          >{{ sub.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileCultivationSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_5'
    }
  },
  data() {
    return {
      bgColor: 'rgba(230, 236, 247, 1)',
      list: [
        {
          code: '',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG550c781bed908837d190f0172606bf4b.png'),
          title: '习近平经济思想与品牌',
          itemList: [
            { code: '', title: '十四届全国人大一次会议在京闭幕 习近平发...', url: '' },
            { code: '', title: '十四届全国人大一次会议举行第五次全体会议...', url: '' },
            { code: '', title: '全国政协十四届一次会议闭幕', url: '' },
            { code: '', title: '十四届全国人大一次会议举行第四次全体会议...', url: '' }
          ],
          url: ''
        },
        {
          code: '',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG550c781bed908837d190f0172606bf4b.png'),
          title: '习近平经济思想与品牌',
          itemList: [
            { code: '', title: '十四届全国人大一次会议在京闭幕 习近平发...', url: '' },
            { code: '', title: '十四届全国人大一次会议举行第五次全体会议...', url: '' },
            { code: '', title: '全国政协十四届一次会议闭幕', url: '' },
            { code: '', title: '十四届全国人大一次会议举行第四次全体会议...', url: '' }
          ],
          url: ''
        },
        {
          code: '',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG550c781bed908837d190f0172606bf4b.png'),
          title: '习近平经济思想与品牌',
          itemList: [
            { code: '', title: '十四届全国人大一次会议在京闭幕 习近平发...', url: '' },
            { code: '', title: '十四届全国人大一次会议举行第五次全体会议...', url: '' },
            { code: '', title: '全国政协十四届一次会议闭幕', url: '' },
            { code: '', title: '十四届全国人大一次会议举行第四次全体会议...', url: '' }
          ],
          url: ''
        }
      ]
    }
  },
  methods: {
    goTo(item) {
      if (!item || !item.url) return
      // url 包含 /zp/a 时，提取后面的 newsCode 跳转到详情页
      if (item.url.includes('/zp/a')) {
        const newsCode = item.url.split('/zp/a/')[1] || item.url.split('/zp/a')[1]
        if (newsCode) {
          this.$router.push(`/detail?newsCode=${newsCode}`)
        }
        return
      }
      // 不包含 /zp/a 时直接跳转原 url
      if (item.url.startsWith('http')) {
        window.open(item.url, '_blank')
      } else {
        this.$router.push(item.url)
      }
    }
  }
}
</script>

<style scoped>
.spm6-cultivation {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm6-cultivation-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.spm6-cultivation-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 12px;
}

.spm6-cultivation-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
  object-fit: cover;
  cursor: pointer;
}

.spm6-cultivation-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  line-height: 22px;
  text-align: center;
  display: block;
  margin-top: 10px;
  cursor: pointer;
}

.spm6-cultivation-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  margin-top: 12px;
}

.spm6-cultivation-sub {
  font-size: 13px;
  color: #666;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
